import React from "react";
import SiteWrapper from "./src/components/SiteWrapper";

export const wrapRootElement = ({ element }) => {
  return <SiteWrapper>{element}</SiteWrapper>;
};
